import React, { useMemo } from 'react';
import { useCountdown } from 'src/hooks/useCountdown';
import { useTranslation } from 'next-i18next';
import dayjs from 'dayjs';
import { TAuctionFormat } from '../../collectible.typing';

const NftCardAuctionTime: React.VFC<{ start: string, end: string, type: TAuctionFormat }> = ({ start, end, type }) => {
    const { t } = useTranslation(['components']);
    const startCD = useCountdown(start);
    const endCD = useCountdown(end);

    const isStarted = dayjs().isAfter(start);

    const locale: {
        finished: string,
        buttonNotStarted: string,
        buttonInProgress: string,
        cardNotStarted: string,
        in: string
    } = useMemo(() => (
        t('countdown', { ns: 'components', returnObjects: true })
    ), [t]);

    const labels: { [key in TAuctionFormat]: { notStarted: string, inProgress: string, finished: string } } = useMemo(()=>({
        'Button': { notStarted: locale.buttonNotStarted, inProgress: locale.buttonInProgress, finished: locale.finished },
        'Card': { notStarted: locale.cardNotStarted, inProgress: '', finished: locale.finished },
        'Table': { notStarted: locale.in, inProgress: '', finished: '' },
    }), [locale]);

    const { days, hours, minutes, seconds, isFinished } = isStarted ? endCD : startCD;

    const label = isStarted ? labels[type].inProgress : labels[type].notStarted;
    const isDays = days > 0;

    let time = isDays && days > 1 ? `${days} days` : `${days} day`;
    if (!isDays) {
        time = `${hours.toString().padStart(2, '0')} : ${minutes.toString().padStart(2, '0')} : ${seconds.toString().padStart(2, '0')}`;
    }

    return (
        <>
            {isFinished ? labels[type].finished : `${label} ${time}`}
        </>
    );
};

export default NftCardAuctionTime;